export const TeamNotePasswordPolicyConstant = {
  NONE: "",
  DEFAULT: "^(?=.*[a-z])(?=.*[A-Z]).+$",
  BOC: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$",
  AVSECO: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$"
}